import { Product } from 'types/schema';

export const isRealProduct = (item: unknown): item is Product =>
  !!item && typeof item === 'object' && !!(item as Product).id;

export const isRecommendationTag = (tags?: string | string[] | null): boolean => {
  if (!tags) {
    return false;
  }
  return tags === 'RECOMMENDED_FOR_YOU' || tags.includes('RECOMMENDED_FOR_YOU');
};

export const checkEmailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
